import React from 'react';
import { Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import * as _ from 'lodash';
import { Link } from 'react-router-dom';

function UploadGuideLink(props) {
  const styles = props.styles && _.isPlainObject(props.styles)
    ? props.styles : {};
    
  return (
    <div className="upload-guide-link" style={styles}>
      <Link to='/guide/PLUS'>
        <Icon type='question-circle' style={{fontSize: 16}} />
        <FormattedMessage id={props.id} defaultMessage={props.defaultMessage} />
      </Link>
    </div>
  )
}

export default UploadGuideLink;